<template lang="pug">
	.creative-dashboard
		Dashboard(v-if="User.loaded && User.User")
		Auth(v-else-if="User.loaded && !User.User")
		.loading(v-else)
			.loading-icon
</template>

<script>
	import Screen 			from './mixins/screen'

	import Dashboard 		from './components/Dashboard/Dashboard'
	import Auth 			from './components/Auth/Auth'

	import { User } 		from './services/User'

	export default {
		name: 'app',
		mixins: [Screen],
		screen: {
			events: {
				"Current User Changed": function() {

					this.$forceUpdate();

				}
			}
		},
		components: {
			Dashboard,
			Auth
		},
		data() {
			this.User = User;
			return {};
		},
		methods: {

		},
		created() {

		}
	}
</script>

<style lang="sass">
	// CoreUI Icons Set
	@import '~@coreui/icons/css/coreui-icons.min.css'
	/* Import Font Awesome Icons Set */
	$fa-font-path: '~font-awesome/fonts/'
	@import '~font-awesome/scss/font-awesome.scss'
	/* Import Simple Line Icons Set */
	$simple-line-font-path: '~simple-line-icons/fonts/'
	@import '~simple-line-icons/scss/simple-line-icons.scss'
	/* Import Flag Icons Set */
	@import '~flag-icon-css/css/flag-icon.min.css'
	/* Import Bootstrap Vue Styles */
	@import '~bootstrap-vue/dist/bootstrap-vue.css'
	// Import Main styles for this application
	@import 'assets/scss/style'

	@import '~bootstrap-icons/font/bootstrap-icons.min.css'

	*
		margin: 0
		padding: 0

	body
		background-color: #2f353a
		width: 100%
		height: 100%
		position: fixed
		top: 0
		left: 0
		overflow: hidden

	fieldset
		border: none

	.creative-dashboard

		.loading
			display: flex
			align-items: center
			width: 100vw
			height: 100vh
			justify-content: center

			.loading-icon
				width: 200px
				height: 200px
				background: url("./../public/img/loading/dual-ring-1s-200px.svg") center no-repeat

</style>
